import { lazyLoad } from 'utils/loadable';

export const NotificationTemplate = lazyLoad(
  () => import('./notificationTemplate.page'),
  (module) => module.NotificationTemplate
);
